import React from "react";
import $ from "jquery";
import "./variable/v";
import * as omnimap from "../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "./functions/callBackFunctions";
import * as CommonFunctions from "./functions/commonFunctions";
import * as GC from "../../../common/common";
import ColumnList from "../../../common/componet-jsons/column-list-mm.json";
import MyContext from "../../../../api/context/my-context";
import { CONSTS } from "../../../common/const";
import {GetSelected, SetSelected} from "../../../common/tableHandler/manipulateTable";
import {DropFromSetSelectedButtonIdsIfSelected, MergeUniquely} from "../../../common/function/functions";
import {GetDataForMapWithSetSelectedCallback} from "../../../common/map/showOnMap/showOnMap";

class Table extends React.Component {
  static contextType = MyContext;
  constructor(props) {
    super(props);
    this.state = {
      settingList: [],
      columnList: [],
      columnListPure: [],
      columnOrderIdentification: "",
      columnOrderReference: "",
    };
  }

  /**(FUNCTION) Tablonun İçine Değerleri Getiren Fonksiyon */
  async fillTable(model, page_number, customResult) {
    window.$mm_work_plans_scroll_change = false;
    window.$mm_work_plans_Glist = [];

    let result

    if (customResult && typeof customResult === 'object'){
      result = customResult
    } else {
      result  = await omnimap.FillTableAction(
          model,
          page_number,
          window.$mm_management_units_token
      );
    }

    await CallBackFunctions.FillTableCallBack(
      result,
      page_number,
      window.$mm_work_plans_columnListPure
    );

    var context = this.context;
    context.actions.spinnerToggle(window.$mm_work_plans_statusCheck);
  }

  /**(FUNCTION) Tabloyu Yenileyen Fonksiyon */
  reloadData(
    page_number,
    ids,
    short_type,
    direction,
    field,
    content = [
      { key: "werkplan-naam", and_or: "AND", values: [], datatype: "STRING" },
    ]
  ) {
    var model;

    if (!short_type) {
      if (ids && ids.length) {
        model = {
          content: [
            {
              and_or: "AND",
              datatype: "STRING",
              key: "werkplan-naam",
              values: ids,
            },
          ],

          sorting: [],
          definitions:
            process.env.REACT_APP_MM_PLANNIG != ""
              ? [process.env.REACT_APP_MM_PLANNIG]
              : [],
        };
      } else {
        model = {
          content: content,
          definitions:
            process.env.REACT_APP_MM_PLANNIG != ""
              ? [process.env.REACT_APP_MM_PLANNIG]
              : [],
          sorting: [],
        };
        window.$mm_work_plans_result = [];
      }
    } else if (short_type) {
      if (ids && ids.length) {
        model = {
          content: content,
          context: [
            {
              role: "Beheereenheid zit in folder",
              instance_identifiers: ids,
              direction: "from",
              and_or: "AND",
              start: "2020-11-09T09:56:22.986Z",
            },
          ],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
          definitions:
            process.env.REACT_APP_MM_PLANNIG != ""
              ? [process.env.REACT_APP_MM_PLANNIG]
              : [],
        };
      } else {
        model = {
          content: content,
          definitions: [process.env.REACT_APP_MM_PLANNIG],
          sorting: [
            {
              sort_type: short_type,
              direction: direction,
              field: field,
            },
          ],
        };
      }
    }

    window.$mm_work_plans_lastUsedTableFilter = model;

    this.fillTable(model, page_number);
    this.fillFilterColumns();
  }

  /**(FUNCTION) Tabloyu Yenileyen Fonksiyon */
  addContentAndFillTable(key, value) {
    var hasRow = $.grep(window.$mm_work_plans_filterContent, function (v) {
      return v.key === key;
    });
    if (hasRow.length > 0) {
      window.$mm_work_plans_filterContent = $.grep(
        window.$mm_work_plans_filterContent,
        function (value) {
          return value !== hasRow[0];
        }
      );
    }
    if (value !== null && key != "status") {
      var values = [];
      values.push(value);
      var contentModel = {
        and_or: "AND",
        datatype: "STRING",
        key: key,
        values: values,
      };
      window.$mm_work_plans_filterContent.push(contentModel);
    }

    var model = {
      content: window.$mm_work_plans_filterContent,
      definitions:
        process.env.REACT_APP_MM_PLANNIG != ""
          ? [process.env.REACT_APP_MM_PLANNIG]
          : [],
      statuses: [],
    };
    if (key == "status" && value != null) {
      model.statuses = [{ status: value, and_or: "AND" }];
    }
    window.$mm_work_plans_lastUsedTableFilter = model;
    this.fillTable(model, 1);
  }

  /**(FUNCTION) Component Açılıdğında Tablo Sütun Arama İnputlarının Dolmasını Sağlayan Fonsiyon. */
  fillFilterColumns(key) {
    var that = this;
    var model = {
      definitions:
        process.env.REACT_APP_MM_PLANNIG != ""
          ? [process.env.REACT_APP_MM_PLANNIG]
          : [],
    };
    $.each(window.$mm_work_plans_columnList, async function (index, data) {
      if (data.id !== "" && data.filter === true) {
        let result = await omnimap
          .FillFilterColumnsAction(
            model,
            data.id,
            window.$mm_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });
        CallBackFunctions.FillFilterColumnsCallBack(data, result);
      }
    });
  }
  /**(FUNCTION) Tabloların sütün Aramlarının Anlık Yapılmasını Sağlayan Fonsiyon. */
  async searchFilterColumns(key, searchId) {
    window.$mm_work_plans_last_search_id = searchId;
    var that = this;
    //filter content bu modelin içine parse edilecek.
    var test = window.$mm_work_plans_filterContent;

    // var test = {
    //   definitions: [process.env.REACT_APP_MM_PLANNIG],
    //   query: {
    //     content: [window.$mm_work_plans_filterContent],
    //     context: [],
    //     definitions: [process.env.REACT_APP_MM_PLANNIG],
    //     statuses: [],
    //   },
    // };
    var tab10 = Array.from(test);

    var model = {
      definitions: [process.env.REACT_APP_MM_PLANNIG],
      query: {
        content: [...window.$mm_work_plans_filterContent],
        context: [],
        definitions: [process.env.REACT_APP_MM_PLANNIG],
        statuses: [],
      },
    };

    let result = await omnimap
      .SearchFilterColumnsAction(
        model,
        key,
        searchId,
        window.$mm_management_units_token
      )
      .catch((error) => {
        console.log(error);
      });
    await CallBackFunctions.SearchFilterColumnsCallBack(searchId, result);
  }

  /*** ---PROPSTAN GELEN TREE VERİSİ İÇERİSİNDE TIKLANAN Lİ'NİN TÜM ALT DALLARINDAKİ İDLERİ GETİRİR--- ***/
  treeParser = (data, beheereenheid) => {
    const that = this;
    data.forEach(function (element) {
      if (element.parentfolder === beheereenheid) {
        window.$mm_work_plans_result.push(element.id);
        if (element.children.length > 0) {
          that.treeParser(element.children, element.id);
        }
      } else if (element.children && element.children.length > 0) {
        that.treeParser(element.children, beheereenheid);
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const that = this;
    if (!that.props.location.state) {
      if (that.props.location.isDidUpdate !== prevProps.location.isDidUpdate) {
        var model = {
          content: [],
          definitions: [process.env.REACT_APP_MM_PLANNIG],
        };
        window.$mm_work_plans_lastUsedTableFilter = model;

        that.reloadData(1);
        document.getElementById("tree-parent-id").setAttribute("value", "");

        var treeClass = document.querySelector(".tree li.open.act");
        var treeDivClass = document.querySelector(".tree li div.open.act");
        if (treeClass !== null) {
          treeClass.removeAttribute("class");
        }
        if (treeDivClass !== null) {
          treeDivClass.classList.remove("open");
          treeDivClass.classList.remove("act");
        }
      } else {
        $("#cover-spin").hide(0);
      }
    } else if (that.props.location.state && prevProps.location.state) {
      if (
        that.props.location.state.isDidUpdate !==
        prevProps.location.state.isDidUpdate
      ) {
        if (that.props.location.state.isDidUpdate == "0038") {
          var model = {
            content: [],
            definitions: [process.env.REACT_APP_MM_PLANNIG],
          };
          // that.setState({ lastUsedTableFilter: model });
          that.reloadData(1);
        } else {
          window.$mm_work_plans_result = [];
          window.$mm_work_plans_result.push(that.props.location.state.id);
          this.treeParser(
            that.props.location.state.TreeList,
            that.props.location.state.id
          );
          if (that.props.location.state.treeLocation !== "modal") {
            that.reloadData(1, window.$mm_work_plans_result);
          }
        }
      }
    } else {
      window.$mm_work_plans_result = [];
      window.$mm_work_plans_result.push(that.props.location.state.id);
      this.treeParser(
        that.props.location.state.TreeList,
        that.props.location.state.id
      );
      if (that.props.location.state.treeLocation !== "modal") {
        that.reloadData(1, window.$mm_work_plans_result);
      }
      $("#cover-spin").hide(0);
    }
  }

  handleShowSelectedButton() {
    window.$set_selected_button_selected_ids = [];
    window.$mm_setShowSelectedButtonOff();

    window.$mm_setShowSelectedButtonOnClick = () => {
      const selected = GetSelected();
      window.$set_selected_button_selected_ids = MergeUniquely(window.$set_selected_button_selected_ids, selected)

      if (!window.$mm_setShowSelectedButtonToggleState){
        window.$mm_work_plans_lastUsedTableFilter.instance_identifications = [];
      } else {
        window.$mm_work_plans_lastUsedTableFilter.instance_identifications = window.$set_selected_button_selected_ids;
      }

      this.fillTable(window.$mm_work_plans_lastUsedTableFilter,
          1,
          window.$set_selected_button_selected_ids.length === 0 && window.$mm_setShowSelectedButtonToggleState? CONSTS.EMPTY_TABLE_RESPONSE: null).then(()=>{
        SetSelected(window.$set_selected_button_selected_ids)
      });
    }
  }

  async componentDidMount() {
    var that = this;
    this.handleShowSelectedButton();
    /***************************************************************************************/
    /**FREE FORMAT */
    var tableHeaderItems;
    var userColumnResult = await omnimap.GetFreeFormatByIdAction(
      CONSTS.USER_ID_STORE
    );
    // userda column sort id'si varmı ?
    if (userColumnResult.meta.total_found == 0) {
      var user = window.localStorage.getItem("accessToken");
      window.$mm_management_units_column_order_users.client_identification =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.code =
        CONSTS.USER_ID_STORE;
      window.$mm_management_units_column_order_users.data.users.push({
        user_id: user.identification,
        id_stores: {
          table_column_order: GC.uuidv4(),
        },
      });
      omnimap
        .GetFreeFormatAction(
          "",
          "POST",
          window.$mm_management_units_column_order_users
        )
        .then(() => {
          // GC.sleep(1500).then(() => this.fillTable());
        });
    }
    //userda column sort id'si var sa else geç
    else {
      let result = await omnimap.GetFreeFormatByIdAction(
        CONSTS.COLUMN_ORDER_MM_WORK_PLANS
      );

      // bu sayfanın column sort'u var mı?
      if (result.meta.total_found == 0) {
        window.$mm_work_plans_column_order_post_model.client_identification =
          CONSTS.COLUMN_ORDER_MM_WORK_PLANS;
        window.$mm_work_plans_column_order_post_model.code =
          CONSTS.COLUMN_ORDER_MM_WORK_PLANS;

        omnimap
          .GetFreeFormatAction(
            "",
            "POST",
            window.$mm_work_plans_column_order_post_model
          )
          .then(() => {
            window.location.reload();
          });
      }
      // bu sayfanın column sort'u varsa else'e geç
      else {
        //burada sayfanın column sortları listenelinr ve table th sıralaması yapılır

        let result = await omnimap.GetFreeFormatByIdAction(
          CONSTS.COLUMN_ORDER_MM_WORK_PLANS,
          "GET"
        );

        await this.setState({
          columnOrderIdentification: result.data[0].identification,
          columnOrderReference: result.data[0].reference,
        });

        result = await result.data[0].data.table_sorting.find(
          (x) => x.name === "management-maintenance>work-plans"
        );

        tableHeaderItems = await result.column_list.map((item, index) =>
          item === "checkbox" ? (
            <th className="sorting_disabled">
              <span className="checkAll" />
              <span className="checkNone" style={{ display: "none" }} />
            </th>
          ) : item === "active" ? (
            <th className="sorting_disabled">
              <span style={{ display: "none" }}>snowflake</span>
            </th>
          ) : item === "status_detailplanning" ? (
            <th>
              <div id="plannig-plannig-svg-filter">
                <div className="plannig-plannig-svg">
                  <span className="table-header-tooltiptext">
                    status_detailplanning
                  </span>
                </div>
              </div>
            </th>
          ) : item === "status_budget" ? (
            <th>
              <div id="plannig-budgetten-svg-filter">
                <div className="plannig-budgetten-svg">
                  <span className="table-header-tooltiptext">
                    status_budget
                  </span>
                </div>
              </div>
            </th>
          ) : item === "status_uitvoering" ? (
            <th>
              <div id="plannig-location-svg-filter">
                <div className="plannig-location-svg">
                  <span className="table-header-tooltiptext">
                    status_uitvoering
                  </span>
                </div>
              </div>
            </th>
          ) : item === "status_werkplan" ? (
            <th>
              <div id="plannig-workoerder-svg-filter">
                <div className="plannig-werkplannen-svg">
                  <span className="table-header-tooltiptext">
                    status_werkplan
                  </span>
                </div>
              </div>
            </th>
          ) : item === "planning_iscorrectiefonderhoud" ? (
            <th>
              <div id="plannig-wrench-svg-filter">
                <div className="plannig-wrench-svg">
                  <span className="table-header-tooltiptext">
                    planning_iscorrectiefonderhoud
                  </span>
                </div>
              </div>
            </th>
          ) : item === "status_verzonden" ? (
            <th>
              <div id="plannig-paper-plane-svg-filter">
                <div className="plannig-paper-plane-svg">
                  <span className="table-header-tooltiptext">
                    status_verzonden
                  </span>
                </div>
              </div>
            </th>
          ) : item === "" ? (
            <th className="sorting_disabled"></th>
          ) : (
            <th key={item}>{item}</th>
          )
        );

        await this.setState({
          columnList: tableHeaderItems,
        });
        window.$mm_work_plans_columnListPure = result;
      }
    }
    /***************************************************************************************/

    ColumnList.forEach(function (item) {
      if (item.name == "mm>work-plans") {
        window.$mm_work_plans_columnList = item["column-list"];
      }
    });

    if (window.$mm_management_units_token == null) {
      GC.GetToken().then((token) => {
        that.setState({ token: token });
        window.$mm_management_units_token = token;
        that.reloadData(1);
        CommonFunctions.DefinationStatus();
      });
    } else {
      that.reloadData(1);
      CommonFunctions.DefinationStatus();
    }

    // Setup - add a text input to each footer cell

    var table = $("#example").DataTable({
      order: [],
      ordering: false,
      orderCellsTop: true,
      fixedHeader: true,
      colReorder: {
        fixedColumnsLeft: 1
      },
      searching: false,
      paging: false,
      scrollX: true, //"500px",

      scrollCollapse: true,
      scrollY: "calc(100vh - 330px)",

      dom: '<"top"if>t<"bottom"pr><"clear">',
      info: true,
      infoCallback: function (settings, start, end, max, total, pre) {
        return (
          '<span class="select-item"></span>' +
          '<span class="total_right"><span id="total-rows" class="total">' +
          end +
          "</span> geselecteerd </span>"
        );
      },
      language: {
        paginate: {
          previous: "Eerste",
          next: "Laatste",
        },
        select: {
          rows: '<span class="items">%d </span>items van&nbsp;', //'<span class="items">%d </span>items van&nbsp;',
        },
      },
      columnDefs: [
        {
          targets: 0,
          data: null,
          defaultContent: "",
          orderable: false,
          className: "select-checkbox",
        },
      ],
      select: {
        style: "multi+shift",
        selector: "tr",
      },
      // Disable sorting on the sorting_disabled class
      aoColumnDefs: [
        {
          bSortable: false,
          aTargets: ["sorting_disabled"],
        },
      ],
      stateSave: true,
      stateSaveCallback: (settings, data) => {
        let result = CallBackFunctions.TableColumnChangeHandler(
          settings,
          data,
          that.state.columnOrderIdentification,
          that.state.columnOrderReference,
          CONSTS.COLUMN_ORDER_MM_WORK_PLANS
        );
        window.$mm_work_plans_columnListPure = result;
      },
    });
    var lastScrollLeft = 0;
    var lastScrollControl = 0.33;
    var buffer = 0.33; // # of pixels from bottom of scroll to fire your function. Can be 0
    $(".dataTables_scrollBody").scroll(function () {
      var documentScrollLeft = $(".dataTables_scrollBody").scrollLeft();
      if (window.$catalog_management_units_scroll_change) {
        if (
          $(".dataTables_scrollBody").prop("scrollHeight") -
            $(".dataTables_scrollBody").scrollTop() <=
          $(".dataTables_scrollBody").height() + buffer
        ) {
          lastScrollControl = 0;
        }
      }
      if (lastScrollLeft == documentScrollLeft + lastScrollControl) {
        if (window.$mm_work_plans_scroll_change) {
          if (
            $(".dataTables_scrollBody").prop("scrollHeight") -
              $(".dataTables_scrollBody").scrollTop() <=
            $(".dataTables_scrollBody").height() + buffer
          ) {
            if (document.getElementById("tableSide").className !== "d-none") {
              if (
                `/${this.baseURI.split("/")[3]}/${
                  this.baseURI.split("/")[4]
                }` === that.props.location.pathname &&
                window.$mm_work_plans_table_total_row_count >
                  process.env.REACT_APP_TABLE_TOTAL_ROW_COUNT
              ) {
                $("#cover-spin").show(0);
                window.$mm_work_plans_page_number++;
                that.fillTable(
                  window.$mm_work_plans_lastUsedTableFilter,
                  window.$mm_work_plans_page_number
                );
              }
            } else window.$mm_work_plans_scroll_change = true;
          }
        }
      }
    });

    // $("#example thead tr").clone(true).appendTo("#example thead");

    $(table.table().header()).addClass("scrollabe-datatable");

    var tes = (document.getElementsByClassName(
      "scrollabe-datatable"
    )[0].parentElement.id = "scrollabe-datatable-id");

    $("#scrollabe-datatable-id thead tr")
      .clone(true)
      .appendTo("#scrollabe-datatable-id thead");

    $("#scrollabe-datatable-id thead tr:eq(1) th").each(function (i) {
      var title = $(this).text();
      if (title && title !== "snowflake" && title !== "active") {
        var row = $.grep(window.$mm_work_plans_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });

        var rowId = row[0].id;
        if (row[0].filter === true) {
          $(this).html(
            '<input type="search" class="col-search" id="' + rowId + '" />'
          );
          $("input", this).on("keyup change", function () {
            if (table.column(i).search() !== this.value) {
              table.column(i).search(this.value).draw();
            }
          });
        } else if (row[0].isFilterIcon === true) {
          $(this).html(`<div class="plannig-filter" id="${rowId}" ></div>`);
        } else {
          $(this).html("");
        }
      } else if (i === 0) {
        $(this).html(
          '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
        );
      } else if (title.includes("snowflake")) {
        $(this).html('<div class="refresh"> </div>');
      } else {
        $(this).html("");
      }

      if (title.includes("_")) {
        var row = $.grep(window.$mm_work_plans_columnList, function (v) {
          return String(v.name).toLowerCase() === String(title).toLowerCase();
        });
        $(this).append(
          '<div class="filter-popup-plannig-table">' +
            '  <span class="popuptext plannig" id="short-table-popup-' +
            row[0].id +
            '" ></span>' +
            "</div>"
        );
      }
      // if (i > 1) {
      //   var title = $(this).text();
      //   var row = $.grep(window.$mm_work_plans_columnList, function (v) {
      //     return v.row === i;
      //   });

      //   var rowId = row[0].id;
      //   if (row[0].filter === true) {
      //     $(this).html(
      //       '<input type="search" class="col-search" id="' + rowId + '" />'
      //     );
      //     $("input", this).on("keyup change", function () {
      //       if (table.column(i).search() !== this.value) {
      //         table.column(i).search(this.value).draw();
      //       }
      //     });
      //   } else if (row[0].isFilterIcon === true) {
      //     $(this).html(`<div class="plannig-filter" id="${rowId}" ></div>`);
      //   } else {
      //     $(this).html("");
      //   }
      // } else if (i === 0) {
      //   $(this).html(
      //     //$(this).html( '<div class="popup threedots" onclick="Popup()"><span class="popuptext" id="myPopup"><a class="maatregelen" href="#">Maatregelen</a><a class="locate" href="#">Beheer gebieden</a><a class="map" href="#">Toon op kaart</a><a class="trash-bin" href="#">Verwijderen</a></span></div>' );
      //     '<div class="popup threedots"><span class="popuptext" id="myPopup"></span></div>'
      //   );
      // } else if (i === 1) {
      //   $(this).html('<div class="refresh"> </div>');
      // } else {
      //   $(this).html("");
      // }

      // if (i > 1 && i < 8) {
      //   var row = $.grep(window.$mm_work_plans_columnList, function (v) {
      //     return v.row === i;
      //   });
      //   $(this).append(
      //     '<div class="filter-popup-plannig-table">' +
      //       '  <span class="popuptext plannig" id="short-table-popup-' +
      //       row[0].id +
      //       '" ></span>' +
      //       "</div>"
      //   );
      // }
    });

    $("#scrollabe-datatable-id thead").on("click", "th", function () {
      var row_index = table.column(this).index();
      var nRow = $("#scrollabe-datatable-id thead tr")[0];

      if (row_index != undefined) {
        if (
          this.childNodes[0].className != "popup threedots" &&
          this.childNodes[0].className != "refresh"
        ) {
          nRow.childNodes.forEach(function (indx) {
            if (indx.cellIndex != row_index) {
              indx.className = "sorting_disabled";
            }
          });

          if (row_index) {
            if (this.className == "sorting_disabled") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$mm_work_plans_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_work_plans_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$mm_work_plans_filterContent
              );
            } else if (this.className == "sorting_asc") {
              this.className = "sorting_desc";
              var row;
              $.each(window.$mm_work_plans_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_work_plans_result,
                row.shortType,
                "DESCENDING",
                row.shortField,
                window.$mm_work_plans_filterContent
              );
            } else if (this.className == "sorting_desc") {
              this.className = "sorting_asc";
              var row;
              $.each(window.$mm_work_plans_columnList, function (index, data) {
                if (data.row == row_index) {
                  row = data;
                }
              });
              that.reloadData(
                1,
                window.$mm_work_plans_result,
                row.shortType,
                "ASCENDING",
                row.shortField,
                window.$mm_work_plans_filterContent
              );
            }
          }

          window.$mm_work_plans_page_number = 1;
        }
      }
    });

    $("#example tbody").on("click", "tr", function () {
      if ($(".checkAll").attr("style") == "display: none;") {
        $(".checkNone, .checkAll").toggle();
      }
      DropFromSetSelectedButtonIdsIfSelected(this);
    });

    //** select all table
    $("#scrollabe-datatable-id").on("click", ".checkAll", function (e) {
      var table = $("#example").DataTable();
      table.rows().select();

      $(".checkNone, .checkAll").toggle();
    });

    //** unselect all table
    $("#scrollabe-datatable-id").on("click", ".checkNone", function (e) {
      var table = $("#example").DataTable();

      table.rows().deselect();
      $(".checkNone, .checkAll").toggle();
      window.$set_selected_button_selected_ids = []
    });

    $("#example_filter input").addClass("search-input-table1");
    $(".search-input-table1").attr("placeholder", "search text");
    $("#example tbody").on("dblclick", "tr", function () {
      // var rowId = this.children[7].innerText;

      var rowId = $(this).attr("rowId");

      $.each(window.$mm_work_plans_Glist, function (index, data) {
        if (data.identification == rowId) {
          window.$mm_work_plans_selectedRow = data;
          window.$mm_work_plans_selectedWorkPlanIdentification = data.werkplanIdentification;
        }
      });
      CommonFunctions.fillDetail();
      $("#tableSide").addClass("d-none");
      $("#detailSide").removeClass("d-none");
    });
    // Option to allow selecting rows by clicking on row besides checkbox.
    // $("#example tbody").on("click", "tr", function () {
    //   $(this).toggleClass("selected");
    // });
    $(".col-search").on("input", function (e) {
      window.$mm_work_plans_searchInputId = this.id;
      if (this.value === "") {
        that.addContentAndFillTable($(this).attr("id"), null);
      }
    });
    table.columns().iterator("column", function (ctx, idx) {
      if (
        window.$mm_work_plans_columnListPure.column_list[idx] === "checkbox" ||
        window.$mm_work_plans_columnListPure.column_list[idx] === "active" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "status_detailplanning" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "status_budget" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "status_uitvoering" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "status_werkplan" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "planning_iscorrectiefonderhoud" ||
        window.$mm_work_plans_columnListPure.column_list[idx] ===
          "status_verzonden"
      ) {
      } else {
        $(table.column(idx).header()).append('<span class="sort-icon"/>');
      }
    });

    function handleRefresh () {
      $("#cover-spin").show(0);
      $("#spinner").removeAttr("hidden");
      window.$mm_work_plans_page_number = 1;
      window.$mm_work_plans_filterLastIds = $.grep(
          window.$mm_work_plans_filterLastIds,
          function (v) {
            $("#short-table-popup-" + v).html("");
            return null;
          }
      );

      document
          .querySelectorAll("div.plannig-filter-green")
          .forEach((element) => {
            element.className = "plannig-filter";
          });
      document.querySelectorAll("div.plannig-filter-red").forEach((element) => {
        element.className = "plannig-filter";
      });
      that.fillTable(window.$mm_work_plans_lastUsedTableFilter, 1);

      // that.reloadData(1);
    }
    window.$mm_work_plans_refresh =handleRefresh;
    $(".refresh").click(handleRefresh);

    $(".back-page-link").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $("div.popup").click(function () {
      var selectedIds = [];
      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      GetActionsOfRow(selectedIds.join(","));
    });
    /*** başlangıç tarihi değiştiğinde, bitiş tarihinin başlangıç tarihinden küçük olmamasını control eder */
    $("#e-startDate").change(function () {
      if (this.value > $("#e-endDate").val()) {
        $("#e-endDate").val(this.value);
      }
      $("#e-endDate").attr("min", this.value);
    });

    $("#algemeen-gisratio").autocomplete({
      source: window.$mm_work_plans_plannigAlgemeenGisratio,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("algemeen-gisratio", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#status").autocomplete({
      source: window.$mm_work_plans_plannigStatus,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("status", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#maatregel-naam").autocomplete({
      source: window.$mm_work_plans_maatregelNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("maatregel-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#werkplan-naam").autocomplete({
      source: window.$mm_work_plans_werkplanNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("werkplan-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#planningspatroon-naam").autocomplete({
      source: window.$mm_work_plans_planningspatroonNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("planningspatroon-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#planningsperiode-naam").autocomplete({
      source: window.$mm_work_plans_planningsperiodeNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("planningsperiode-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#budget-naam").autocomplete({
      source: window.$mm_work_plans_budgetNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("budget-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#beheereenheid-naam").autocomplete({
      source: window.$mm_work_plans_beheereenheidNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("beheereenheid-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#beheeractiviteit-laag").autocomplete({
      source: window.$mm_work_plans_beheeractiviteitLaag,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("beheeractiviteit-laag", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#discipline-naam").autocomplete({
      source: window.$mm_work_plans_disciplineNaam,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("discipline-naam", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });
    $("#status-tijdstip_verzonden").autocomplete({
      source: window.$mm_work_plans_statusTijdstipVerzonden,
      // select: function (event, ui) {
      //   that.addContentAndFillTable("status-tijdstip_verzonden", ui.item.value);
      // },
      open: function (e, ui) {
        $(".ui-autocomplete").css(
          "top",
          $("ul.ui-autocomplete").cssUnit("top")[0] + 2
        );
      },
    });

    $("#algemeen-gisratio").on("input", function () {
      // window.$mm_work_plans_plannigAlgemeenGisratio.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#status").on("input", function () {
      // window.$mm_work_plans_last_search_id = this.id;
      // get the current value of the input field.
    });
    $("#maatregel-naam").on("input", function () {
      // window.$mm_work_plans_maatregelNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#werkplan-naam").on("input", function () {
      // window.$mm_work_plans_werkplanNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#planningspatroon-naam").on("input", function () {
      // window.$mm_work_plans_planningspatroonNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#planningsperiode-naam").on("input", function () {
      // window.$mm_work_plans_planningsperiodeNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#budget-naam").on("input", function () {
      // window.$mm_work_plans_budgetNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#beheereenheid-naam").on("input", function () {
      // window.$mm_work_plans_beheereenheidNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#beheeractiviteit-laag").on("input", function () {
      // window.$mm_work_plans_beheeractiviteitLaag.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#discipline-naam").on("input", function () {
      // window.$mm_work_plans_disciplineNaam.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });
    $("#status-tijdstip_verzonden").on("input", function () {
      // window.$mm_work_plans_statusTijdstipVerzonden.length = 0;
      that.searchFilterColumns($(this).val(), this.id);
      // get the current value of the input field.
    });

    async function GetActionsOfRow(rowIds) {
      let result = await omnimap
        .GetActionsOfRowAction(rowIds, window.$mm_management_units_token)
        .catch((error) => {
          console.log(error);
        });

      CallBackFunctions.GetActionsOfRowCallback(result);
    }

    $(".plannig-filter").click(function (e) {
      let id = this.id;

      var clickColumn = $.grep(
        window.$mm_work_plans_filterLastIds,
        function (v) {
          return v === id;
        }
      );
      if (clickColumn.length == 0) {
        window.$mm_work_plans_filterLastIds.push(this.id);
        $("#short-table-popup-" + this.id).html("");

        var filterRowActive = $(`<div id="${this.id}-input-true"></div>`)
          .attr({ name: "true" })
          .addClass("filter-popup-plannig-table")
          .html(
            '<label id="' +
              this.id +
              "-input-true" +
              '" class="filter-container">Actief<input type="checkbox" >' +
              '<span id="' +
              this.id +
              '-input-true" class="checkmark-green"></span>' +
              "</label>"
          );

        var filterRowFalse = $(`<div id="${this.id}-input-false"></div>`)
          .attr({ name: "false" })
          .addClass("filter-popup-plannig-table")
          .html(
            '<label id="' +
              this.id +
              "-input-false" +
              '" class="filter-container">Inactief<input type="checkbox" >' +
              "<span id=" +
              this.id +
              "-input-false" +
              ' class="checkmark-red"></span>' +
              "</label>"
          );
        $("#short-table-popup-" + this.id).append(
          filterRowActive,
          filterRowFalse
        );
      }

      var openElement = document.getElementsByClassName(
        "popuptext plannig show"
      );
      if (openElement.length > 0) {
        openElement[0].className = "popuptext plannig";
      }

      var BreakException = {};

      try {
        window.$mm_work_plans_filterClickControl.forEach(function (v) {
          if (v[0] === id) {
            v[1] = !v[1];

            if (!v[1]) {
              $("#short-table-popup-" + v[0]).removeClass("show");
              // throw BreakException;
            }
          } else {
            v[1] = false;
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      try {
        window.$mm_work_plans_filterClickControl.forEach(function (v) {
          if (v[0] === id) {
            if (v[1]) {
              var popup = document.getElementById("short-table-popup-" + id);
              popup.classList.toggle("show");
              throw BreakException;
            }
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
    });

    $(".filter-popup-plannig-table")
      .unbind("click")
      .click(function (e) {
        var id = e.target.id; //$(this).attr("id");
        if (window.$mm_work_plans_gvv == 0 && id !== undefined) {
          let column_id = id.split("-")[0] + "-" + id.split("-")[1];

          if (String(id).includes("true")) {
            document.getElementById(column_id).className =
              "plannig-filter-green";
          } else if (String(id).includes("false")) {
            document.getElementById(column_id).className = "plannig-filter-red";
          }

          let boolChange;
          var BreakException = {};

          try {
            window.$mm_work_plans_filterCheckControl.forEach(function (v) {
              if (v[0] === column_id) {
                if (id.includes("true")) {
                  v[1] = !v[1];
                  v[2] = false;
                } else {
                  v[2] = !v[2];
                  v[1] = false;
                }
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }

          if (id.includes("true")) {
            window.$mm_work_plans_filterCheckControlGPlannig[0] =
              !window.$mm_work_plans_filterCheckControlGPlannig[0];
            window.$mm_work_plans_filterCheckControlGPlannig[1] = false;
          } else {
            window.$mm_work_plans_filterCheckControlGPlannig[1] =
              !window.$mm_work_plans_filterCheckControlGPlannig[1];
            window.$mm_work_plans_filterCheckControlGPlannig[0] = false;
          }

          let allFilterCheckStatus;

          //filterların renklerinin ayarlandığı fonksiyon
          window.$mm_work_plans_filterCheckControl.forEach((data) => {
            if (!data[1] && !data[2]) {
              document.getElementById(data[0]).className = "plannig-filter";
            }
          });

          try {
            window.$mm_work_plans_filterCheckControl.forEach((data) => {
              if (!data[1] && !data[2]) {
                allFilterCheckStatus = true;
              } else {
                allFilterCheckStatus = false;
                throw BreakException;
              }
            });
          } catch (e) {
            if (e !== BreakException) throw e;
          }

          if (allFilterCheckStatus) {
            window.$mm_work_plans_filterContent = [
              {
                key: "werkplan-naam",
                and_or: "AND",
                values: [],
                datatype: "STRING",
              },
            ];
            that.reloadData(1);
            window.$mm_work_plans_gvv++;
            document.getElementById(column_id).className = "plannig-filter";
          } else {
            if (id.includes("true")) {
              document.getElementById(`${column_id}-input-false`).remove();
              boolChange = false;
              that.filterMaatregelenIsActive = [true];
            } else {
              document.getElementById(`${column_id}-input-true`).remove();
              boolChange = true;
              that.filterMaatregelenIsActive = [false];
            }

            var filterRowFalse = $(
              `<div id="${id.split("-")[0]}-${
                id.split("-")[1]
              }-input-${boolChange}"></div>`
            )
              .attr({ name: `${boolChange}` })
              .addClass("filter-popup-plannig-table")
              .html(
                `<label id="${id.split("-")[0]}-${
                  id.split("-")[1]
                }-input-${boolChange}" class="filter-container">${
                  boolChange ? "Actief" : "Inactief"
                }
                <input type="checkbox" id="${id.split("-")[0]}-${
                  id.split("-")[1]
                }-input-${boolChange}">
                <span  id="${id.split("-")[0]}-${
                  id.split("-")[1]
                }-input-${boolChange}"  class="${
                  boolChange ? "checkmark-green" : "checkmark-red"
                }"></span>
                </label>`
              );

            boolChange
              ? $(`#short-table-popup-${column_id}`).prepend(filterRowFalse)
              : $(`#short-table-popup-${column_id}`).append(filterRowFalse);
            window.$mm_work_plans_gvv++;

            var hasRow = $.grep(
              window.$mm_work_plans_filterContent,
              function (v) {
                if (v.values[0] == false) {
                  return v.key === column_id;
                } else if (v.values[0] == true) {
                  return v.key === column_id;
                }
              }
            );
            if (hasRow.length > 0) {
              window.$mm_work_plans_filterContent = $.grep(
                window.$mm_work_plans_filterContent,
                function (item) {
                  if (item.values[0] == false) {
                    return item !== hasRow[0];
                  } else if (item.values[0] == true) {
                    return item !== hasRow[0];
                  }
                  // bu sadece plannig türevi compontlarda uygulanmalıdır.
                  else if (item.key == "werkplan-naam") {
                    return item;
                  }
                }
              );
            }

            var tryCheck = true;
            try {
              window.$mm_work_plans_filterCheckControl.forEach((data) => {
                if (
                  data[0] === column_id &&
                  data[1] == false &&
                  data[2] == false
                ) {
                  tryCheck = false;
                  throw BreakException;
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            }

            if (tryCheck) {
              var model = {
                key: `${id.split("-")[0]}-${id.split("-")[1]}`,
                and_or: "AND",
                values: that.filterMaatregelenIsActive,
                datatype: "BOOLEAN",
              };
              window.$mm_work_plans_filterContent.push(model);
            }

            that.reloadData(
              1,
              null,
              null,
              null,
              null,
              window.$mm_work_plans_filterContent
            );
          }
        }
      });

    $(document)
      .unbind("click")
      .on("click", ".ui-menu-item-wrapper", function (e) {
        $("#" + window.$mm_work_plans_last_search_id).val(e.target.innerText);
        $("*[id*=ui-id]:visible").each(function () {
          $(this).css("display", "none");
        });

        that.addContentAndFillTable(
          window.$mm_work_plans_searchInputId,
          e.target.innerText
        );
      });

    $(document).on("click", ".action", function () {
      GetDataForMapWithSetSelectedCallback(window.$mm_work_plans_lastUsedTableFilter, "work-plans");
    });

    $(document).on("click", ".mm_work_plans_action", function () {
      var actionId = $(this).attr("id");
      let modalId = window.$mm_work_plans_actions.filter(
        (act) => act["id"] === actionId
      )[0]["modal"];
      $("#" + modalId).modal("show");
    });
  }

  render() {
    return (
      <div id="tableSide">
        <MyContext.Consumer>
          {(context) => (
            <div
              className="inf"
              style={{ display: context.spinnerIsOpen ? "block" : "none" }}
            >
              <div className="buttons_top">
                <a role="button" className="button noicon" id="mappen_beheren">
                  Alle werkregels zijn verwerkt
                </a>
              </div>
              <div className="buttons_top_information">
                <i className="ico-information"></i>
                {/* <span>Beheerobjecten per beheereenheid</span> */}
              </div>
            </div>
          )}
        </MyContext.Consumer>

        <table id="example" className="table-hover table min-full-width">
          <thead>
            <tr>
              {this.state.columnList}
              {/* <th className="sorting_disabled">
                <span className="checkAll" />
                <span className="checkNone" style={{ display: "none" }} />
              </th>
              <th className="sorting_disabled"></th>
              <th>
                <div id="plannig-plannig-svg-filter">
                  <div class="plannig-plannig-svg">
                    <span class="table-header-tooltiptext">Detailplanning</span>
                  </div>
                </div>
              </th>
              <th>
                <div id="plannig-budgetten-svg-filter">
                  <div class="plannig-budgetten-svg">
                    <span class="table-header-tooltiptext">Budget</span>
                  </div>
                </div>
              </th>
              <th>
                <div id="plannig-location-svg-filter">
                  <div class="plannig-location-svg">
                    <span class="table-header-tooltiptext">Uitvoering</span>
                  </div>
                </div>
              </th>
              <th>
                <div id="plannig-workoerder-svg-filter">
                  <div class="plannig-werkplannen-svg">
                    <span class="table-header-tooltiptext">Werkplan</span>
                  </div>
                </div>
              </th>
              <th>
                <div id="plannig-wrench-svg-filter">
                  <div class="plannig-wrench-svg">
                    <span class="table-header-tooltiptext">
                      Correctief onderhoud
                    </span>
                  </div>
                </div>
              </th>
              <th>
                <div id="plannig-paper-plane-svg-filter">
                  <div class="plannig-paper-plane-svg">
                    <span class="table-header-tooltiptext">
                      Verzonden naar uitvoering
                    </span>
                  </div>
                </div>
              </th>
              <th>Gisratio Id</th>
              <th>Status</th>
              <th>Naam maatregel</th>
              <th>Laag</th>
              <th>Naam beheereenheid</th>
              <th>Naam discipline</th>
              <th>Tijdstip verzonden</th>
              <th>Datum aangemaakt</th>
              <th>Datum laatst gewijzigd</th> */}
            </tr>
          </thead>
          <tbody></tbody>
        </table>
        <input id="tree-parent-id" hidden />
      </div>
    );
  }
}

export default Table;
